<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="组织名称">
            <el-input clearable v-model="queryParams.deptName" placeholder="请输入组织名称进行查询"
              class="form-item-width"></el-input>
          </el-form-item>
          <div class="btn-boxs">
            <div></div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table v-loading="tableLoading" :data="tableData" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="647"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }">
        <!-- 多选 -->
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green', cursor: 'pointer' } : { color: 'red', cursor: 'pointer' }">{{
          scope.row.status === '0' ? '正常' : '停用' }}</span>
            <!-- 其他列的常规展示 -->
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="addData(scope.row)" class="update-btn">新增</el-button>
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <!-- <div>
        <Pagination
           background
          :total="pageParams.total"
          :page="pageParams.pageNum"
          :limit="pageParams.pageSize"
          @pagination="onChangePages"
        />
      </div>-->
    </div>
    <!-- 添加 修改组织 -->
    <el-dialog :title="dialogTitle" :visible.sync="deptFormVisible" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="组织名称" prop="deptName">
          <el-input v-model="form.deptName" autocomplete="off" placeholder="请输入组织名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="leader">
          <el-input v-model="form.leader" autocomplete="off" placeholder="请输入负责人"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="orderNum">
          <el-input v-model="form.orderNum" autocomplete="off" placeholder="请输入显示顺序"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" autocomplete="off" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="组织状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择组织状态">
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重 置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Pagination from "@/components/Pagination";
import {  getDeptTree,deptAdd, deptById, updeteDept, deleteDept} from "@/api/admin-service/dept";
export default {
  components: {
    // Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        ancestors: "", //祖级列表
        parentId: "", //新增 需要上级id 默认是第一级
        deptName: "", //组织名称
        leader: "", //负责人
        orderNum: "", //显示顺序
        phone: "", //联系电话
        status: "" //组织状态
        // delFlag: "0" // ?
      },
      rules: {
        deptName: [
          { required: true, message: "请填写组织名称", trigger: "blur" }
        ],
        leader: [{ required: true, message: "请填写负责人", trigger: "blur" }],
        orderNum: [
          {
            required: true,
            message: "请填写显示顺序",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              // 校验是否为正整数且大于 0
              if (!value) {
                callback(new Error("请填写显示顺序"));
              } else if (!/^[1-9]\d*$/.test(value)) {
                callback(new Error("显示顺序必须是大于 0 的正整数"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请填写联系电话",
            trigger: "blur"
          },
          {
            pattern: /^1[3-9]\d{9}$/, // 正则表达式，匹配中国大陆手机号
            message: "请输入合法的手机号",
            trigger: "blur"
          }
        ],
        status: [
          { required: true, message: "请选择组织状态", trigger: "change" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      deptFormVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "组织名称", code: "deptName", width: "" },
        { name: "负责人", code: "leader", width: "" },
        { name: "显示顺序", code: "orderNum", width: "" },
        { name: "电话", code: "phone", width: "" },
        { name: "组织状态", code: "status", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        parentId: 0,
        deptName: "",
        orderBy: ""
      }
    };
  },
  mounted() {
    this.onGetDataList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    addData(row) {
      this.form.parentId = row.parentId;
      let currentNode = row;
      // 初始化 ancestors 数组
      this.form.ancestors = [];
      // 递归查找父节点并包含当前节点的 deptId
      while (currentNode) {
        this.form.ancestors.push(currentNode.deptId); // 将当前节点的 deptId 加入数组
        // 如果当前节点有父节点，继续向上查找
        if (currentNode.parentId === null) {
          break;
        }
        currentNode = this.findNodeById(currentNode.parentId); // 查找父节点
      }
      // 逆序 ancestors 数组，使其从第一级到最后一级
      this.form.ancestors.reverse();
      // 将数组转化为逗号分隔的字符串
      const ancestorsString = this.form.ancestors.join(",");
      // 打印父节点的 ID 列表
      this.dialogTitle = "新增";
      // this.form.parentId = row.deptId; //新增 需要上级id 默认是第一级
      this.deptFormVisible = true;
      // 打印字符串结果
      // 如果你需要将字符串保存到 form 中，可以这样做：
      this.form.ancestors = ancestorsString;
    },
    // 根据节点 ID 查找节点
    findNodeById(id) {
      // 遍历所有节点找到对应的节点
      const find = nodes => {
        for (let node of nodes) {
          if (node.deptId === id) return node;
          if (node.children) {
            const result = find(node.children);
            if (result) return result;
          }
        }
        return null;
      };
      return find(this.tableData);
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.deptId; // 清除 userId
            deptAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteDept({
              ...this.form,
              deptId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(
        `提示，确定要删除 <span style="color: red; font-weight: bold;">${row.deptName}</span> 及其下属的所有数据吗？`,
        {
          title: "提示",
          showCancelButton: true,
          confirmButtonText: "确 定",
          cancelButtonText: "取 消",
          type: "warning",
          // 为按钮添加图标并设置为 mini 尺寸
          confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
          cancelButtonClass: "el-icon-close el-button--mini", // 取消按钮的图标和尺寸
          dangerouslyUseHTMLString: true // 允许渲染 HTML 字符串
        }
      )
        .then(() => {
          deleteDept({ ids: [row.deptId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.deptFormVisible = true;
      this.updateId = row.deptId;
      deptById({ id: row.deptId }).then(res => {
        Object.assign(this.form, res?.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getDeptTree({})
        .then(res => {
          this.tableData = res.data;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handledeptAdd() {
      this.dialogTitle = "新增";
      this.deptFormVisible = true;
    },
    handleDialogClose() {
      this.form.deptId = "";
      this.form.parentId = "";
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      this.queryParams.deptName = "";
      this.onSearch();
    }
    // 分页方法
    // onChangePages(pageInfo) {
    //   this.pageParams.pageNum = pageInfo.page;
    //   this.pageParams.pageSize = pageInfo.limit;
    //   this.onGetDataList();
    // }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
